import React from 'react'

import { HrStyled } from './styled'

export default ({ ...props }) => (
  <HrStyled {...props} />
)
